$(document).ready(function () {
    let x=8;
    let to_show = 8;
    let size_li = $(".accordion-item.active").length;
    if (size_li > to_show) {
      $('.load-more-module').removeClass('hide')
    }
    let percentage = (x / size_li)*100;
    $('.fill').css('width', percentage+'%');
    $('.accordion-item.active:lt('+x+')').removeClass('hide');
    $('.accordion-item.active:lt('+x+')').addClass('active');
    $('#viewed-count').html(x)
    $('.loadMore').click(function () {
        x= (x+to_show <= size_li) ? x+to_show : size_li;
        $('#viewed-count').html(x)
        percentage = (x / size_li)*100;
        $('.fill').css('width', percentage+'%');
        $('.accordion-item.active:lt('+x+')').removeClass('hide');
        $('.accordion-item.active:lt('+x+')').addClass('active');
        if(x == size_li){
            $('.fill').css('width', '100%');
            $('.loadMore').hide();
        }
    });
  });
